import React from 'react';


function Footer() {
    return (
        <footer>
            Credits: Episode data is originally
            from the fantastic <a href="https://tvmaze.com/">TVmaze</a> via
            their <a href="https://www.tvmaze.com/api">API</a>.
        </footer>
    )
}


export default Footer;